import React, { PureComponent } from 'react';
import moment from 'moment';
import 'moment/min/locales';
import { ScrollView, StyleSheet } from 'react-native';
import { View } from '@dbk/ui-react-utils';
import { createContainer } from '@dbk-legacy/muster/react';
import { Tabs, Tab } from '@dbk/ui-tabs';
import { Refresh , Timepicker , Info2 } from '@dbk/ui-icons';
import { DatePicker, Utils } from '@dbk/ui-datepicker';
import { Toast } from '@dbk/ui-notifications'
import Text, { Large,H3 } from '@dbk/ui-text';
import isEmpty from 'lodash/fp/isEmpty';
import { CUSTOM_REPORT_SELECTED_RANGE } from '../../../../@extension/CH/src/screens/reports/constants';
import { ChangeIndicatedCurrency } from '../../../components/common/number';
import additionalStyles from '../../data-exports/custom-transactions.styles';
import { LoadingCircle } from '../../../components/common/loading';
import { PALETTE , BRANCH_CODE , DATE_AVALOQ, KEY_CODE, EBANKINGWEBUK, RM_REGION_UK} from '../../../constants';
import envConfig from '../../../../db-env-build';
import GenericDateSelectionBar from '../../../components/common/date-selection-bar';
import { currentDateText } from '../../../utils/date';
import { FormattedMessage } from '@dbk-legacy/format';
import { Radio } from '@dbk/ui-forms';
import { IconButton } from '@dbk/ui-buttons';
import { QuestionMark } from '../../../components/common/icons';
import InverseProvider from '@dbk/ui-inverse';
import Button from '@dbk/ui-buttons';
import { Currency } from '../../../../src/components/common/number';
import Popover from '@dbk/ui-popover';
import { formatDate } from '../../../../@extension/CH/src/screens/reports/report-utils';
import labelForPFid from '../../../utils/portfolio-number-aria-label';
import { ROUTES } from '../../../constants';

const today = moment().format('YYYY-MM-DD');
const weekAgo = moment().subtract(6, 'd').format('YYYY-MM-DD');
const monthAgo = moment().subtract(30, 'd').format('YYYY-MM-DD');
const trimonthAgo = moment().subtract(3, 'months').format('YYYY-MM-DD');
const currentYearDate = moment().startOf('year').format('YYYY-MM-DD');
const firstDayOfYear = moment().startOf('year');
class SummaryCashAccountsDetails extends PureComponent {

  constructor(props) {
    super(props);
    const asOfDate = moment().format('DD-MM-YYYY');
    
    this.state = {
     selectedTab: 0,
     showCurBalPopover : false,
     value: {
      from: moment(currentYearDate, "DD-MM-YYYY"),
      to: moment(asOfDate, "DD-MM-YYYY")
  },
    selectedViewByDate: this.props.cashAccounts.bookingDateType || '',
    showTotalMktValPopover: false,
    startDate: this.getStartDate(this.props.selectedPortfolioData.branchCode.toString())
    };

    this.props.setFromDate(weekAgo);
    this.props.setEndDate(today);
  }

  componentDidMount() {
    this.props.cashAccountBookings();
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.selectedPortfolioData &&
      this.props.selectedPortfolioData.id !== nextProps.selectedPortfolioData.id
    ) {
      this.props.goBack();
      this.props.cashAccountBookings();
    } 
  }

  componentWillUnmount() {
    this.props.setcashAccountData({});
    this.props.setbookings({});
    this.props.setLoading(false);
  }

  handleCurBalancePopover = (value) => {
     this.setState({ showCurBalPopover: value });
  }

  componentDidUpdate(prevProps , prevState) {
  if( this.state.selectedViewByDate !== prevState.selectedViewByDate){
      const value= this.state.selectedViewByDate
      this.props.setBookingDateType(value);
      this.props.cashAccountBookings();
      } 
    if(this.state.value.from && this.state.value.to){
      if(document.querySelector('#applybtnFocus')){
        document.querySelector('#applybtnFocus').focus();
      }
    }
  }
//WMCE-36301- Introducing View By 
  onRadioSelectedViewByDate(value){
    this.setState({selectedViewByDate: value});
    this.props.setBookingDateType(value);
  }

getStartDate(branchCode){   //WMCE-36301-for setting calender starting date as region- wise avaloq go live date 
  switch(branchCode){
    case BRANCH_CODE.branchCodeCH : 
      return moment(DATE_AVALOQ.dateCH,'DD.MM.YYYY');
    case BRANCH_CODE.branchCodeUK :
      return moment(DATE_AVALOQ.dateUK,'DD.MM.YYYY');
    case BRANCH_CODE.branchCodeLUX :
      return moment(DATE_AVALOQ.dateLux,'DD.MM.YYYY');
    default :
      return moment(DATE_AVALOQ.defaultDate,'DD.MM.YYYY');
  }
}

  onSelectTime(selectedTab, e) {
    const { setFromDate, setEndDate, cashAccountBookings, setbookings } = this.props;
    if((e && e.keyCode && (e.keyCode === KEY_CODE.ENTER_KEY || e.keyCode === KEY_CODE.SPACE_KEY)) || (!e)){
    this.setState({
      selectedTab
    });
    setbookings({});
    if (selectedTab === CUSTOM_REPORT_SELECTED_RANGE.CUSTOM) {
      setFromDate(currentYearDate);
      setEndDate(today);
      this.setState({
        value: {
          from:moment(firstDayOfYear.format('DD-MM-YYYY'), "DD-MM-YYYY").toDate(),
          to:moment(moment().format('DD-MM-YYYY'), "DD-MM-YYYY").toDate()
        }
     });
    }

    switch (selectedTab) {
      case CUSTOM_REPORT_SELECTED_RANGE.LAST_WEEK:
        setFromDate(weekAgo);
        break;
      case CUSTOM_REPORT_SELECTED_RANGE.LAST_MONTH:
        setFromDate(monthAgo);
        break;
      case CUSTOM_REPORT_SELECTED_RANGE.PAST_THREE_MONTHS:
        setFromDate(trimonthAgo);
        break;
      default:
        break;
    }
    setEndDate(today);
    cashAccountBookings();
    }
  }

  renderRows(rows, langCode) {
    return rows.map((row, index) => {
   const valueDate = moment(row.valueDate,'MMM DD,YYYY').format('YYYY-MM-DD');  //WMCE-36301- For comparing value date with today's date 
   const receivedDate = row.valueDate ? formatDate(row.valueDate, langCode): "";
   const newTxnDate = row.txnDate ? formatDate(row.txnDate, langCode): "";
   const isFutureDate= moment(valueDate).isAfter(today);
   const isFutureValueDate=(this.state.selectedViewByDate==='VALUE' && isFutureDate);
   const textStyle={color:isFutureValueDate ? PALETTE.warning: null, fontStyle:isFutureValueDate ? 'italic': null};
   const bookingType= row.bookingType === 'CUSTOM' ? additionalStyles.rootCustom : additionalStyles.root
   return(
      
      <View style={StyleSheet.flatten(bookingType)} key={`${index}+1`}>
        <View style={StyleSheet.flatten(additionalStyles.container)}>
          {
          this.state.selectedViewByDate==='VALUE' ? 
          
          <View style={StyleSheet.flatten(additionalStyles.transValueDateContainer)}>
          <View tabIndex={receivedDate ? 0 : -1} style={[StyleSheet.flatten(additionalStyles.listItemStart),StyleSheet.flatten(additionalStyles.valueDate)]}>
            <Text style={textStyle}>{receivedDate}</Text>
            {isFutureValueDate && <div style={{marginLeft:10}}><Timepicker color={PALETTE.warning}></Timepicker></div>}
          </View>
          <View tabIndex={newTxnDate ? 0 : -1} style={additionalStyles.listItemStart}>
            <Text style={textStyle} >{newTxnDate}</Text>
          </View>
          </View>
          :
          <View style={StyleSheet.flatten(additionalStyles.transValueDateContainer)}>
          <View tabIndex={newTxnDate ? 0 : -1} style={[StyleSheet.flatten(additionalStyles.listItemStart),StyleSheet.flatten(additionalStyles.transDate)]}>
            <Text>{newTxnDate}</Text>
          </View>
          <View tabIndex={receivedDate ? 0 : -1} style={additionalStyles.listItemStart}>
            <Text>{receivedDate}</Text>
          </View>
          </View>
          }
          <View tabIndex={0} style={[StyleSheet.flatten(additionalStyles.listItemFirst) ,StyleSheet.flatten(additionalStyles.description)]}>
            <Text style={textStyle}>{row.description} </Text>
          </View>
          <View tabIndex={row.reference? 0 : -1} style={[StyleSheet.flatten(additionalStyles.listItemReference) , StyleSheet.flatten(additionalStyles.reference)]}>
            <Text style={textStyle}>{row.reference}</Text>
          </View>
          <View tabIndex={row.debit ? 0 : -1 } style={[StyleSheet.flatten(additionalStyles.listItem) , StyleSheet.flatten(additionalStyles.debit)]}>
            {(!row.debit || row.debit === null || row.debit === undefined || row.debit === 0) ?
              <Text></Text> : (
                <div>
                  <ChangeIndicatedCurrency
                    value={parseFloat(row.debit)}
                   renderProps={{ size: 'small', style: additionalStyles.date, color: PALETTE.secondaryActive ,isFutureValueColor:isFutureValueDate}}
                    onlyNegativeStyling
                    currency={row.ccyTrade}
                  />
                </div>
              )}
          </View>
          <View tabIndex={row.credit? 0: -1} style={[StyleSheet.flatten(additionalStyles.listItem) , StyleSheet.flatten(additionalStyles.credit)]}>
            {(!row.credit || row.credit === null || row.credit === undefined || row.credit === 0) ?
              <Text></Text> : (
                <div>
                  <ChangeIndicatedCurrency
                    value={parseFloat(row.credit)}
                    renderProps={{ size: 'small', style: additionalStyles.date, color: PALETTE.secondaryActive ,isFutureValueColor:isFutureValueDate }}
                    onlyNegativeStyling
                    currency={row.ccyTrade}
                  />
                </div>
              )}
          </View>
          <View tabIndex={0} style={[StyleSheet.flatten(additionalStyles.listItem) , StyleSheet.flatten(additionalStyles.balance)]}>
            {row.balance === null ? (
              '-'
            ) : (
              <div>
                <ChangeIndicatedCurrency
                  value={parseFloat(row.balance)}
                 renderProps={{ size: 'small', style: additionalStyles.date, color: PALETTE.secondaryActive ,isFutureValueColor:isFutureValueDate}}
                  onlyNegativeStyling
                  currency={row.ccyTrade}
                />
              </div>
            )}
          </View>
        </View>
      </View>
    );});
  }

  onDateClicked = (selectionStart) => {
    const { setFromDate, setEndDate, cashAccountBookings } = this.props;
        this.setState({
     value: {
        ...this.state.value,
        ...selectionStart,
    }
    });
    setFromDate(moment(selectionStart.from).format('YYYY-MM-DD'));
    setEndDate(moment(selectionStart.to).format('YYYY-MM-DD'));
  };
  
  onRefreshClick = (e) => {
    if((e && e.keyCode && (e.keyCode === KEY_CODE.ENTER_KEY || e.keyCode === KEY_CODE.SPACE_KEY)) || (!e)){
    this.props.cashAccountBookings();
    }
  }

  onApplyDateChange = () => {
    const { setFromDate, setEndDate, cashAccountBookings } = this.props;
    setFromDate(moment(this.state.value.from).format('YYYY-MM-DD'));
    setEndDate(moment(this.state.value.to).format('YYYY-MM-DD'));
    cashAccountBookings();
    this.onCancel();
  }


  onCancel = () => {
    this.datepickerRef.close();
    this.props.setDatePickerClose(false);
  }

  customFooter = () => {
    const { i18n: { messages } } = this.props;
    return <InverseProvider inverse style={{ borderBottom: "1px solid #535b61", width: "100%", height: "65px", backgroundColor: '#12213c', paddingTop: "15px" }} >
      <div style={{ width: "45%", display: "inline-grid", float: 'left' }} tabIndex={0}>
        <Text style={{ padding: "5px" }}>{messages['app.chedelivery.reports.customReports.today']}{moment().format('DD-MMM-YYYY')}</Text>
      </div>
      <div className='calenderFooterButton'>
        <Button tertiary
          onClick={() => this.onCancel()}
        >{messages['app.chedelivery.reports.customReports.cancelButton']}</Button>

        <Button
          id="applybtnFocus"
        disabled={!(this.state.value.from && this.state.value.to)}
          onClick={() => this.onApplyDateChange()}
        >{messages['app.chedelivery.reports.apply']}</Button>
      </div>
    </InverseProvider>
  }

  onMoreDetailsClick = () => {
    this.props.changePage(ROUTES.CASH_ACCOUNTS.SUMMARY_CASH_ACCOUNTS_MORE_DETAILS);
  }

  render() {
    const {
      i18n: { messages },
      cashAccounts: { bookings, fromDate, endDate, cashAccountData, isLoading, bookingsHasMore },
      languages: { destLanguage },
      auth: { langCode },
    } = this.props;

    const { selectedTab , showCurBalPopover} = this.state;
    const bookingList = !isEmpty(bookings) ? bookings.bookingList : [];
    const filterCashList = !isEmpty(cashAccountData) ? cashAccountData : [];
    const currentDate = moment(moment().format('DD-MM-YYYY'), "DD-MM-YYYY").toDate();
    const startDate = moment(this.state.startDate.format('DD-MM-YYYY'), "DD-MM-YYYY").toDate();
    const bookingListLength = bookingList && bookingList.length - 2;
    const curBalSign = Math.sign(filterCashList.balance);    //WMCE-36301-38474--To display negative current balance and accured interest in red color
    const curBalStyleColor = curBalSign === -1 ? additionalStyles.negativeDate : additionalStyles.date ;
    const curBalDecimalStyle = curBalSign === -1 ? additionalStyles.negativeDecimalStyle : additionalStyles.decimalStyle;
    const accInterestSign = Math.sign(filterCashList.accruedInterest)
    const accInterestStyleColor = accInterestSign === -1 ? additionalStyles.negativeDate : additionalStyles.date ;
    const accInterestDecimalStyle = accInterestSign === -1 ? additionalStyles.negativeDecimalStyle : additionalStyles.decimalStyle;

    return (
      <div >
        <div>
          <div className="row large-collapse">
            <div className="profile-container">
              <div id="cash_account_header" className="cash_account_header">
                <H3 className='header-main margin-1' tabIndex={0}>{filterCashList.name}</H3>
                {(envConfig.envConfig === EBANKINGWEBUK || envConfig.rmRegion === RM_REGION_UK) && <div className='header-child'>
                  <div className='inline-row'>
                    <Text tabIndex={0} className="margin-right-5" secondary size={"large"}>{messages['app.cashAccounts.label.moreDetails']}</Text>
                    <div tabIndex={0} role='link' aria-label={messages['app.cashAccounts.label.moreDetails']} onClick={() => this.onMoreDetailsClick()}>
                      <Info2 color={PALETTE.primaryText} width={30} height={30}/>
                    </div>
                  </div>
                </div>}
                {(envConfig.envConfig !== EBANKINGWEBUK && envConfig.rmRegion !== RM_REGION_UK) && <div>
                <div className='header-child'>
                  <div tabIndex={0}><Text secondary size={"large"}>{messages['app.cashAccounts.label.iban']}: </Text><Text size={"large"}>{filterCashList.iban}</Text></div>
                  <div tabIndex={0} aria-label={messages['app.common.pageTitle.portfolio']+": " + labelForPFid((filterCashList.pfId))}><Text secondary size={"large"}>{messages['app.common.pageTitle.portfolio']}: </Text><Text size={"large"}>{filterCashList.pfId}</Text></div>
                </div>
                <div className='header-child-cur-bal'>
                 
                  <div style={StyleSheet.flatten(additionalStyles.curBalDiv)}>
                    <div tabIndex={0}>
                    <Text secondary size={"large"} style={StyleSheet.flatten(additionalStyles.curBalLabel)}>{messages['app.cashAccounts.label.currentBalance']}: </Text>   
                      <span>
                      <Currency
                      signBeforeNumber={false}
                      decimalStyle={curBalDecimalStyle}
                      currencyStyle={additionalStyles.currencyStyleHeader}
                      currency={filterCashList.cashAccCurrency}
                      renderProps={{ style: curBalStyleColor, color: PALETTE.secondaryActive }} 
                      value= { (filterCashList.balance) ? filterCashList.balance: 0}
                      />
                    </span>
                  </div>
                  <div style={StyleSheet.flatten(additionalStyles.curBalDivPopover)}> 
                  <Popover
                   mode="popup"
                   orientation="top"
                   showOnHover
                   popOverClassName="cur-bal-popover"
                   arrowColor={PALETTE.secondaryActive}
                  content={<div>{messages["app.cashAccounts.summary.curBalancePopoverContent"]}</div>}
                  >
                  <div aria-label={messages['app.cashAccounts.label.currentBalance'] + messages['app.cashAccounts.informationIcon'] + messages["app.cashAccounts.summary.curBalancePopoverContent"]}>
                    <Info2 color={PALETTE.fordGray} height={29} width={29}/>
                 </div>
                 </Popover>
                 </div>
                </div>
                  
                <div tabIndex={0}>
                  <Text secondary size={"large"}>{messages['app.common.portfolio.bondsAsset.accInt']}: </Text>
                   <Currency
                    signBeforeNumber={false}
                    decimalStyle={accInterestDecimalStyle}
                    currencyStyle={additionalStyles.currencyStyleHeader}
                    currency={filterCashList.cashAccCurrency}
                    renderProps={{ style: accInterestStyleColor, color: PALETTE.secondaryActive }} 
                    value= {(filterCashList.accruedInterest) ? filterCashList.accruedInterest:0}
                    />           
                  </div>
                </div>
                </div>}
                <div className={`rows view-by-class ${envConfig.envConfig === EBANKINGWEBUK ? 'margin-top-18' : ''}`}>                
                  <div className={destLanguage === "Deutsch" ? "header-child1-lang" : "header-child1"}>
                    <div>
                      <Text secondary size={"large"} tabIndex={0}>{messages['app.cashAccounts.label.viewBy']}:</Text>
                    </div>
                  </div>
                  <div className={envConfig.envConfig === EBANKINGWEBUK ? 'row-uk-container' : ''}>
                    <div className='radio-header'>
                      <Radio
                        title={messages['app.cashAccounts.label.transactionDate']}
                        className="transactionDateRadioButton"
                        value="TRANSACTION"
                        checked={this.state.selectedViewByDate === "TRANSACTION" || this.state.selectedViewByDate === ''}
                        onChange={() => this.onRadioSelectedViewByDate("TRANSACTION")}
                      />
                      <div tabIndex={0}>{messages['app.cashAccounts.label.transactionDate']}</div>
                    </div>
                    <div className='radio-header'>
                      <Radio
                        title={messages['app.cashAccounts.label.valueDate']}
                        className="valueDateRadioButton"
                        value="VALUE"
                        checked={this.state.selectedViewByDate === "VALUE"}
                        onChange={() => this.onRadioSelectedViewByDate("VALUE")}
                      />
                      <div tabIndex={0}>{messages['app.cashAccounts.label.valueDate']}</div>
                    </div>
                  </div>
                </div>

              </div>
              {bookingsHasMore && <Toast underline status="information"
                className='toastCashAccount'
                onClose={() => this.props.setBookingsHasMore(false)}>
                <FormattedMessage
                  id={'app.cashAccounts.warning.exceedResult'}
                  values={{ bookingListLength }} />
              </Toast>}
              <View className='tab_cashAccount'>
                <Tabs
                  secondary
                  stretch
                  handleSelectedIndex={index => this.onSelectTime(index)}
                  selectedIndex={selectedTab}
                >
                  <Tab className='tab_cashAccount_column tabFocus' onKeyDown={(e) => this.onSelectTime(0, e)} testID="tab_cashAccount_7days_cashAccountDetails_test" renderLabel={() => <div aria-label={messages['app.incomehistory.7days'] + messages['app.payment.pageTitle.filterPayment']} > {messages['app.incomehistory.7days']} </div>}/>
                  <Tab className='tab_cashAccount_column tabFocus' onKeyDown={(e) => this.onSelectTime(1, e)} testID="tab_cashAccount_30days_cashAccountDetails_test" renderLabel={() => <div aria-label={messages['app.report.transactionHistory.30days'] + messages['app.payment.pageTitle.filterPayment']}>{messages['app.report.transactionHistory.30days']}</div>}/>
                  <Tab className='tab_cashAccount_column tabFocus' onKeyDown={(e) => this.onSelectTime(2, e)} testID="tab_cashAccount_3months_cashAccountDetails_test" renderLabel={() => <div aria-label={messages['app.report.transactionHistory.90days'] + messages['app.payment.pageTitle.filterPayment']}>{messages['app.report.transactionHistory.90days']}</div>}/>
                  <Tab className='tab_cashAccount_column tabFocus' onKeyDown={(e) => this.onSelectTime(3, e)} testID="tab_cashAccount_date_cashAccountDetails_test" renderLabel={() => <div aria-label={messages['app.cashAccounts.selectDatePicker']}>{messages['app.maturities.overview.tabs.labels.custom']}</div>}/>
                </Tabs>
              </View>

              <div className="row">
                <div id="text_cash_account_header_test" className="text_cash_account_show columns small-6 medium-7 large-9 padding-bottom-10">
                <span tabIndex={0} className="refreshIcon" onKeyDown={(e) => this.onRefreshClick(e)} onClick={() => this.onRefreshClick()} aria-label={messages['app.payments.refreshPayment']} role="button">
                  <Refresh className="refreshIcon" id="refresh" width={30} height={30} color={PALETTE.primaryText} />
                </span>
                  {/* <GenericDateSelectionBar
                    text={currentDateText(fromDate.toString(), endDate.toString(), messages)}
                  /> */}
                </div>
                <span className="columns small-6 medium-5 large-3 ">
                  {selectedTab === CUSTOM_REPORT_SELECTED_RANGE.CUSTOM &&
                    <div className="customReportCalendar">
                      <View id="datepicker_cash_account_details" className="calendarContainer">
                         {!this.props.logoutPopup.isVisible && <DatePicker
                           ref={(ref) => this.datepickerRef = ref}
                           tetherProps={{attachment : "left center"}}
                           showOutsideMonthDays={false}
                           canChangeMonth
                           enableYearNavigation
                           enableRangeSelection
                           onChange={this.onDateClicked}
                           value={this.state.value}
                           endDate={currentDate}
                           startDate={startDate}
                           inputDateFormat={'dd MMM yyyy'}
                           rangeSeparator={' - '}
                           renderFooter={() => this.customFooter()}
                           locale={this.props.auth.langCode}
                           weekStartsOn={1} // Monday is the first day of the week.
                        />}
                      </View>
                    </div>
                  }  </span>
              </div>
            </div>
          </div>
        </div>

        <View className="container_cash_account">
          {
            <View>
              {isLoading === true ?
               <View style={StyleSheet.flatten(additionalStyles.loadingData)}><LoadingCircle /></View>
                :
                <div id="container_cash_account_details_test">
                  {bookingList && bookingList.length > 0 ?
                    <div><View style={StyleSheet.flatten(additionalStyles.headerRoot)}>
                     <View style={StyleSheet.flatten(additionalStyles.container)}>
                      
                      {this.state.selectedViewByDate === 'VALUE' ?
                       <View style={StyleSheet.flatten(additionalStyles.transValueDateContainer)}>
                         <View style={[StyleSheet.flatten(additionalStyles.listItemStart) , StyleSheet.flatten(additionalStyles.valueDate)]}>
                          <Text secondary style={{color:PALETTE.primaryActive}} tabIndex={0}>{messages['app.report.transactionHistory.valueDate']}</Text>
                        </View>
                        <View >
                          <Text secondary tabIndex={0}>{messages['app.common.portfolio.bonds.transDate']}</Text>
                        </View> 
                        </View> :
                        <View  style={[StyleSheet.flatten(additionalStyles.firstContainer),StyleSheet.flatten(additionalStyles.transValueDateContainer)]}>
                        <View style={[StyleSheet.flatten(additionalStyles.listItemStart),StyleSheet.flatten(additionalStyles.transDate)]}>
                        <Text secondary style={{color:PALETTE.primaryActive}} tabIndex={0}>{messages['app.common.portfolio.bonds.transDate']}</Text> 
                        </View>
                        <View>
                        <Text secondary tabIndex={0}>{messages['app.report.transactionHistory.valueDate']}</Text>
                        </View>
                        </View> }
                        <View style={[StyleSheet.flatten(additionalStyles.listItemFirst) ,StyleSheet.flatten(additionalStyles.description)]}>
                          <Text secondary tabIndex={0}>{messages['app.report.transactionHistory.desc']}</Text>
                        </View>
                        <View style={[StyleSheet.flatten(additionalStyles.listItemReference) , StyleSheet.flatten(additionalStyles.reference)]}>
                          <Text secondary tabIndex={0}>{messages['app.chedelivery.reports.customReports.txn.reference']}</Text>
                        </View>
                        <View style={[StyleSheet.flatten(additionalStyles.listItem) , StyleSheet.flatten(additionalStyles.debit)]}>
                          <Text secondary tabIndex={0}>{messages['app.cashAccounts.debit']}</Text>
                        </View>
                        <View style={[StyleSheet.flatten(additionalStyles.listItem) , StyleSheet.flatten(additionalStyles.credit)]}>
                          <Text secondary tabIndex={0}>{messages['app.common.pageTitle.credit']}</Text>
                        </View>
                        <View style={[StyleSheet.flatten(additionalStyles.listItem) , StyleSheet.flatten(additionalStyles.balance)]}>
                          <Text secondary tabIndex={0}>{messages['app.common.portfolio.bonds.balance']}</Text>
                        </View>
                      </View>
                    </View>
                      <div className="scrollBarHoverCash">
                        <ScrollView
                          className="scrollBarHideCash" id="scrollBarHide"
                          ref={r => this.rootView = r}
                        >{this.renderRows(bookingList, langCode)}
                        </ScrollView>
                      </div>
                    </div>
                    :
                     //WMCE-40317- To fix datepicker positioning issue in case of no record
                    <div className="noRecordScreen">  
                    <div className="text-center margin-top-20">
                      <Text tabIndex={0} role="alert" aria-label={messages['app.reports.noRecords']}> {messages['app.reports.noRecords']}</Text>
                    </div>
                    <div className="restScreen"></div>
                    </div>
                  }
                </div>
              }
            </View>
          }
        </View>
      </div>
    );
  }
}

export default createContainer({
  $queries: {
    changePage: { $call: 'ui.history.push' },
    i18n: {
      messages: true,
    },
    languages: {
      destLanguage: true
    },
    cashAccountBookings: { $call: 'cashAccounts.bookingList' },
    setFromDate: { $set: 'cashAccounts.fromDate' },
    setBookingDateType : { $set: 'cashAccounts.bookingDateType' },
    setbookings: { $set: 'cashAccounts.bookings' },
    setcashAccountData: { $set: 'cashAccounts.cashAccountData' },
    setEndDate: { $set: 'cashAccounts.endDate' },
    setLoading: { $set: 'cashAccounts.isLoading' },
    setBookingsHasMore: { $set: 'cashAccounts.bookingsHasMore' },
    cashAccounts: {
      cashAccountData: true,
      bookings: true,
      fromDate: true,
      endDate: true,
      isLoading: true,
      positionObjId: true,
      bookingsHasMore: true,
      bookingDateType :true,
    },
    setRange7Days: {
      $call: 'cashAccounts.setRange7Days'
    },
    setRange30Days: {
      $call: 'cashAccounts.setRange30Days'
    },
    setRange3Months: {
      $call: 'cashAccounts.setRange3Months'
    },
    setDatePickerClose: {
      $set: 'reports.closeDatePicker'
    },
    app: {
      user: {
        selectedPortfolioData: true
      },
    },
    auth: {
      langCode: true,
    },
    logoutPopup: { isVisible: true },
    goBack: { $call: 'ui.history.goBack' },
  },
}, ({ app, ...queries }) => ({
  ...queries,
  selectedPortfolioData: app.user.selectedPortfolioData
}))(SummaryCashAccountsDetails);

export { SummaryCashAccountsDetails };
